import { FormToggle } from '@tryhackme/thm-ui-components';
import { StyledBottomLine, StyledFormRowDescription, StyledFormRowHeading, StyledTaskFormRowContainer, StyledTaskFormRowHeadingContainer } from './task-form-row.styles';
import { TaskFormRowProps } from './task-form-row.types';
export const TaskFormRow = ({
  heading,
  description,
  children,
  showFieldDisableToggle = false,
  setIsFieldDisable,
  fieldEnabled
}: TaskFormRowProps) => <>
    <StyledTaskFormRowContainer data-sentry-element="StyledTaskFormRowContainer" data-sentry-source-file="task-form-row.tsx">
      <StyledTaskFormRowHeadingContainer data-sentry-element="StyledTaskFormRowHeadingContainer" data-sentry-source-file="task-form-row.tsx">
        <StyledFormRowHeading data-sentry-element="StyledFormRowHeading" data-sentry-source-file="task-form-row.tsx">{heading}</StyledFormRowHeading>
        {showFieldDisableToggle && <FormToggle checked={Boolean(fieldEnabled)} aria-label="release date toggle" data-testid="release-date-toggle" onCheckedChange={setIsFieldDisable} />}
      </StyledTaskFormRowHeadingContainer>
      <StyledFormRowDescription data-sentry-element="StyledFormRowDescription" data-sentry-source-file="task-form-row.tsx">{description}</StyledFormRowDescription>
      {children}
    </StyledTaskFormRowContainer>

    <StyledBottomLine data-sentry-element="StyledBottomLine" data-sentry-source-file="task-form-row.tsx" />
  </>;